// src/components/InvalidLinkPage.js
import React from "react";
import { Link } from "react-router-dom";
import logo from '../../assets/logo.svg'; // Import the logo

export default function InvalidLinkPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 text-center">
      {/* Logo */}
      <Link to="/" className="mb-6">
        <img src={logo} width={500} height={100} alt="logo" />
      </Link>

      {/* Header */}
      <h1 className="text-3xl font-semibold mb-4 text-primary">
        The link you provided is not valid
      </h1>

      {/* Explanation */}
      <div className="max-w-md text-gray-600">
        <p className="mb-2">This could be due to the following reasons:</p>
        <ul className="list-disc list-inside text-left">
          <li>The link has expired</li>
          <li>The link was revoked</li>
          <li>The link has already been used</li>
          <li>The link is currently being used</li>
        </ul>
      </div>
    </div>
  );
}
